module.exports = __webpack_public_path__ + "static/media/qingdao_pic3.681d2a3e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/qingdao_pic3.jpg
 ** module id = 472
 ** module chunks = 0
 **/